import { render, staticRenderFns } from "./ExpirePromotion.vue?vue&type=template&id=c2f30aa6&scoped=true&"
import script from "./ExpirePromotion.vue?vue&type=script&lang=js&"
export * from "./ExpirePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f30aa6",
  null
  
)

export default component.exports